import React from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative w-full bg-[#0f1b2d] text-[#f5f0e8] pt-12 pb-20 px-4 md:pt-20 md:pb-32 overflow-hidden" data-id="element-101">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-102">
        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-block px-4 py-1.5 rounded-full border border-[#25D366]/30 bg-[#25D366]/10 text-[#25D366] font-bold text-sm md:text-base mb-8 tracking-wide" data-id="element-103">
          Guía práctica · 14 días · 5h/semana
        </motion.div>

        {/* Main Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-4xl md:text-6xl lg:text-7xl font-black leading-tight mb-6 tracking-tight" data-id="element-104">
          <span className="text-[#25D366]" data-id="element-105">100€ Extra/semana</span>
          <br data-id="element-106" />
          por WhatsApp
        </motion.h1>

        {/* Subtitle */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="text-xl md:text-2xl text-[#f5f0e8]/90 font-medium max-w-2xl mb-10" data-id="element-107">
          Tu primer micro-servicio vendible en 14 días (sin cambiar de trabajo)
        </motion.p>

        {/* Product Mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.25
      }} className="relative w-full max-w-2xl mb-12 rounded-2xl overflow-hidden shadow-2xl shadow-[#25D366]/10 border border-[#f5f0e8]/10" data-id="element-108">
          <img src="https://cdn.magicpatterns.com/uploads/jNQ6qaiCVGWVy17sTKEu2j/100semana_mock_up.png" alt="100€ Extra/semana por WhatsApp Mockup" className="w-full h-auto object-cover" data-id="element-109" />
        </motion.div>

        {/* Sub-headlines */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="flex flex-col md:flex-row gap-4 md:gap-8 text-[#f5f0e8]/70 text-sm md:text-base font-medium mb-12" data-id="element-110">
          <div className="flex items-center justify-center gap-2" data-id="element-111">
            <span className="w-1.5 h-1.5 rounded-full bg-[#25D366]" data-id="element-112"></span>5
            horas/semana
          </div>
          <div className="flex items-center justify-center gap-2" data-id="element-113">
            <span className="w-1.5 h-1.5 rounded-full bg-[#25D366]" data-id="element-114"></span>
            2–3 clientes
          </div>
          <div className="flex items-center justify-center gap-2" data-id="element-115">
            <span className="w-1.5 h-1.5 rounded-full bg-[#25D366]" data-id="element-116"></span>
            40–70€ por entrega
          </div>
        </motion.div>

        {/* Opening Lead */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.7,
        delay: 0.4
      }} className="max-w-2xl text-left md:text-center text-lg md:text-xl leading-relaxed text-[#f5f0e8]/80 mb-12 space-y-4" data-id="element-117">
          <p data-id="element-118">Llegas a casa, tiras las llaves, miras el móvil.</p>
          <p data-id="element-119">No por ocio. Por cálculo.</p>
          <p data-id="element-120">
            Y ahí está lo irónico:{' '}
            <strong className="text-[#f5f0e8]" data-id="element-121">el mismo WhatsApp</strong> que
            usas para todo… también puede ser la forma más simple de sacar un
            extra sin montar un circo.
          </p>
        </motion.div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} className="flex flex-col items-center gap-3" data-id="element-122">
          <a href="#final-cta" onClick={e => {
          e.preventDefault();
          document.getElementById('final-cta')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }} className="group relative w-full justify-center bg-[#25D366] hover:bg-[#20bd5a] text-[#0f1b2d] font-black text-xl md:text-2xl py-5 md:py-6 px-12 md:px-16 rounded-2xl shadow-[0_0_40px_rgba(37,211,102,0.4)] hover:shadow-[0_0_60px_rgba(37,211,102,0.6)] transition-all duration-300 transform hover:scale-105 flex items-center gap-3" data-id="element-123">
            Quiero empezar hoy
            <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-124" />
          </a>
          <span className="text-[#f5f0e8]/60 text-sm font-medium flex items-center gap-2 justify-center" data-id="element-125">
            <span className="line-through opacity-60" data-id="element-126">29€</span>
            <span className="bg-red-500/90 text-white text-xs font-bold px-2 py-0.5 rounded" data-id="element-127">
              -78%
            </span>
            <span className="text-[#25D366] font-bold text-base" data-id="element-128">6,36€</span>
          </span>
        </motion.div>
      </div>
    </section>;
}